import useNewVersionCheck from './hooks/useNewVersionCheck';
import useRouteRestore from './hooks/useRouteRestore';

const NewVersionChecker = () => {
  // Restore route after version update refresh
  useRouteRestore();
  // Check for new versions and auto-refresh if needed
  useNewVersionCheck();
  return null;
};

export default NewVersionChecker;
